// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2jS8k","content":"LayoutSettings_content__2_aMQ"};